import React, { useState } from 'react';
import { Person, BoxArrowLeft, List } from 'react-bootstrap-icons';
import {
    Collapse,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    NavItem, NavLink,
    ButtonGroup,
    Button,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
    UncontrolledDropdown
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import './NavMenu.css';

function AdminNavMenu({ offcanvasIsOpen, setOffcanvasIsOpen, role, token }) {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const dropdownToggle = () => setDropdownOpen(!dropdownOpen);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const getClientsToExcel = () => {
        fetch(`/api/reportsservice/getclientstoexcel/`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }).then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Clients.xlsx";
                link.click();
            })
            .catch(console.error);
    }

    return (
        <header>
            <Navbar className="navbar-expand-lg navbar-toggleable-lg ng-white border-bottom box-shadow mb-3" light>

                <NavbarBrand onClick={() => {
                    navigate("/admin")
                    setIsOpen(false)
                }
                }
                ><img style={{ maxHeight: "50px" }} src="../../lc-logo-5-season.png" alt='Logo-LC' /></NavbarBrand>
                <NavbarToggler className="mr-2" onClick={toggle} />
                <Collapse className="d-lg-inline-flex flex-lg-row-reverse" isOpen={isOpen} navbar>
                    <ul className="navbar-nav">
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" onClick={() => {
                                setIsOpen(false)
                            }} to="/admin">Главная</NavLink>
                        </NavItem>
                        {(role === "Admins" || role === "Buh" || role === "Сashier" || role === "BookingManager" || role === "Marketing") &&
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    Заказы
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => {
                                        setIsOpen(false)
                                        navigate('catalog')
                                    }}>Создать заказ</DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={() => {
                                        setIsOpen(false)
                                        navigate("orders")
                                    }}>История заказы</DropdownItem>

                                    {/* <DropdownItem divider /> */}
                                    {/* <DropdownItem>Another Action</DropdownItem> */}
                                    {/* <DropdownItem divider /> */}
                                    <DropdownItem divider />
                                    <Link className={'dropdown-item'} to={'ticketslc'}>
                                        Билеты ЛЦ
                                    </Link>
                                    <DropdownItem
                                        onClick={() => {
                                            setIsOpen(false)
                                            navigate("orders/certeficate")
                                        }}
                                    >Заказы сертификатов ЛЦ</DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>}
                        {(role === "Admins" || role === "Buh" || role === "Сashier" || role === "BookingManager" || role === "Marketing") &&
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    Отчеты
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => {
                                        setIsOpen(false)
                                        navigate('reports/igora')
                                    }}>Сертификаты Игора-Драйв</DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={() => {
                                        setIsOpen(false)
                                        navigate('/admin/reports/internet-orders')
                                    }}>Продажи на сайте по дате мероприятия</DropdownItem>
                                    <DropdownItem onClick={() => {
                                        setIsOpen(false)
                                        navigate('reports/ticketssite')
                                    }}>Продажи билетов на сайте</DropdownItem>
                                    {/* <DropdownItem divider /> */}
                                    {/* <DropdownItem divider /> */}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        }

                        {(role === "Admins" || role === "Buh" || role === "Сashier" || role === "BookingManager" || role === "Marketing") &&
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    Клиенты
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem disabled>
                                        Создать клиента
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={() => {
                                        setIsOpen(false)
                                        navigate("clients")
                                    }}>
                                        Клиенты
                                    </DropdownItem>
                                    {(role === "Admins") &&
                                        <DropdownItem onClick={() => {
                                            getClientsToExcel()
                                        }}>
                                            Список клиентов
                                        </DropdownItem>
                                    }
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        }
                        {(role === "Admins" || role === "Buh") &&

                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    Товары
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => navigate("products")}>
                                        Товаров
                                    </DropdownItem>
                                    <DropdownItem onClick={() => navigate("categories")}>
                                        Категории товаров
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={() => navigate("agents")} >
                                        Агенты
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        }
                        {/* <NavItem>
                            <NavLink tag={Link} className="text-dark" onClick={() => {
                                setIsOpen(false)
                            }} to='sessionevents'>Списки</NavLink>
                        </NavItem> */}
                        <UncontrolledDropdown>
                            <DropdownToggle nav caret>Списки</DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => {
                                    navigate("/admin/sessionevents")
                                    setIsOpen(false)
                                }}>
                                    Списки
                                </DropdownItem>
                                <DropdownItem onClick={() => {
                                    navigate("/admin/scanner")
                                    setIsOpen(false)
                                }}>
                                    Сканнер
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>

                        <NavItem className='d-flex ms-sm-3'>
                            <ButtonGroup className='flex-fill'>
                                {(role === "Admins") &&
                                    <Button size='sm' color='light' onClick={
                                        () => {
                                            setOffcanvasIsOpen(!offcanvasIsOpen)
                                            toggle()
                                        }}>
                                        <List className='me-1' size='14' />Меню
                                    </Button>
                                }
                                <Button color="info" size='sm' className='' onClick={() => navigate("/")}>
                                    <Person className='me-1' size='14' />Профиль
                                </Button>
                                <Button color="danger" size='sm' outline onClick={() => navigate("/logout")}>
                                    <BoxArrowLeft className='me-1' size='14' />Выход
                                </Button>
                            </ButtonGroup>
                        </NavItem>
                    </ul>
                </Collapse>
            </Navbar>
        </header >
    )
}
export { AdminNavMenu };